import type { TagAssociation } from '~/services/TagsService';

export type TagAssociationRow = TagAssociation & {
  hotelId: string | null;
  experienceId: string | null;
};

export function mapTagAssociationRows(associations: Array<TagAssociation>): Array<TagAssociationRow> {
  return associations.map((association) => ({
    ...association,
    hotelId: association.entities.find((entity) => entity.entityType === 'HOTEL')?.entityId ?? null,
    experienceId: association.entities.find((entity) => entity.entityType === 'EXPERIENCE')?.entityId ?? null,
  }));
}
